import React from "react";
import PropTypes from "prop-types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";

import Dialog, { DialogContent, DialogActions } from "components/common/Dialog";
import CustomButton from "components/common/Button";

import "./TimesheetResultModal.scss";

function TimesheetResultModal({ open, onClose, isSuccess }) {
  const icon = isSuccess ? (
    <CheckCircleIcon className="result-icon success-icon" />
  ) : (
    <WarningIcon className="result-icon error-icon" />
  );

  const message = isSuccess
    ? "Timesheet has been updated successfully."
    : "Unable to save changes to your timesheet. Please try again.";

  const buttonLabel = isSuccess ? "Done" : "Okay";

  const dialogContent = (
    <DialogContent>
      <div className="result-modal-content">
        <div className="icon-wrapper">{icon}</div>
        <p className="result-message">{message}</p>
      </div>
    </DialogContent>
  );

  const dialogActions = (
    <DialogActions
      action2={<CustomButton size="large" label={buttonLabel} onClick={onClose} variant="contained" color="primary" />}
    />
  );

  return (
    <Dialog open={open} onClose={onClose} size="xs" fullWidth={false} content={dialogContent} actions={dialogActions} />
  );
}

TimesheetResultModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool.isRequired,
};

export default TimesheetResultModal;
